// TESTS:
// const config = {
//   apiKey: 'AIzaSyCboDfHROh7suUiKYKh-raORX7CZYileqY',
//   authDomain: 'neolivrostest.firebaseapp.com',
//   databaseURL: 'https://neolivrostest.firebaseio.com',
//   projectId: 'neolivrostest',
//   storageBucket: 'neolivrostest.appspot.com',
//   messagingSenderId: '1039712968089'
// }

const config = {
  apiKey: 'AIzaSyDX5OKe8v8qL4VOROwfnysbGvlfjsuNIgw',
  authDomain: 'atelierporamora-e7bd5.firebaseapp.com',
  databaseURL: 'https://atelierporamora-e7bd5.firebaseio.com',
  projectId: 'atelierporamora-e7bd5',
  storageBucket: 'atelierporamora-e7bd5.appspot.com',
  messagingSenderId: '812222905160'
}

export default config



// WEBPACK FOOTER //
// ./src/firebase_config/config.js